module.exports = __webpack_public_path__ + "static/media/item_24_3.742d7df0.png";